import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Analytics from 'analytics-opencare';

import SingleSelect from '../../../common/components/SingleSelect/SingleSelect';
import {
  OptionBlock,
  Subtitle,
  Title,
} from '../../../common/styled-components';
import { useFunnelStorage } from '../../../funnel/storage/Storage';
import { StepWrapper } from '../../styled-components';
import { CONCIERGE_KEY, generateStepAnalytics } from '../../utils';

import { CHOICES, reasons } from './constants';

const analytics = new Analytics();

const Parent = ({ position, moveToNextStep, setSubStep }) => {
  const storage = useFunnelStorage();
  const savedReason = storage.get(CONCIERGE_KEY.REASON);

  const selectReason = (selectedReasonId, index) => {
    const choice = reasons.find(reason => reason.id === selectedReasonId);

    analytics.trackClick({
      pageType: analytics.pageTypes.CONCIERGE,
      pageName: 'concierge_reason',
      name: 'wizard',
      section: 'reason',
      position: [index + 1],
      ...generateStepAnalytics(position, storage, {
        reason: choice.title,
      }),
    });

    const isComplete = selectedReasonId === CHOICES.CHECKUP_CLEANING;

    storage.save(
      CONCIERGE_KEY.REASON,
      {
        reason: choice.title,
        reasonId: choice.id,
        reasonPartnerId: choice.reasonPartnerId,
      },
      isComplete,
    );

    if (isComplete) {
      moveToNextStep();
    } else {
      setSubStep(selectedReasonId);
    }
  };

  return (
    <div data-testid="main-reason">
      <Title id="title">Why are you visiting the dentist?</Title>
      <Subtitle>
        Your choice helps us get you the best care - even for checkups!
      </Subtitle>
      <StepWrapper>
        <form>
          <OptionBlock row={3}>
            {reasons.map((reason, i) => (
              <SingleSelect
                key={reason.id}
                name="reason"
                id={reason.id}
                title={reason.title}
                description={reason.description}
                describedBy="title"
                Icon={reason.icon}
                onChange={e => selectReason(e, i)}
                selected={get(savedReason, 'reason') === reason.title}
              />
            ))}
          </OptionBlock>
        </form>
      </StepWrapper>
    </div>
  );
};

Parent.propTypes = {
  position: PropTypes.string,
  moveToNextStep: PropTypes.func.isRequired,
  setSubStep: PropTypes.func.isRequired,
};

export default Parent;
